import QuotationsRepository from "../../Repository/QuotationsRepository";
import { v4 as uuidv4 } from "uuid";
import BillsRepository from "../../Repository/BillsRepository";
import LedgersRepository from "../../Repository/LedgersRepository";
import DefaultRepository from "../../Repository/DefaultRepository";
import { Toast } from "../components/Toast";

export const createQuotation = async (state, id = "", change, opds, paid) => {
  let srnums = uuidv4();
  let { data } = await QuotationsRepository.quotationModel({
    request: {
      method: "saveQuotation",
      data: {
        quotation: {
          ledger_type: state.new_ledger.ledger_type,
          company_code: localStorage.getItem("companyCode"),
          ledger_id: id ? id : "",
          subTotal: state.subTotal,
          srNum: srnums,
          discounts: state.discount,
          discount_type: state.discountType,
          total: parseInt(state.Total - state.discAmount),
          paid: paid,
          change: change < 0 ? change : 0,
          customerName: state.customer,
          date: +new Date(),
          status: "In Process",
          items: opds,
          notes: state.notes,
          makeInvoice: false,
        },
      },
    },
  });
  if (data.response.status.statusCode == 200) {
    Toast("info", "New Quotation Created");
  } else {
    Toast("info", "Quotation Not Created");
  }
};
export const updateQuotation = (Quote) => {
  return QuotationsRepository.quotationModel({
    request: {
      method: "updateQuotation",
      data: {
        quotation: Quote,
      },
    },
  });
};

export const createQuoteBill = (bill) => {
  return BillsRepository.billsModel({
    request: {
      method: "saveBills",
      data: {
        bill: {
          _id: bill._id,
          company_code: localStorage.getItem("companyCode"),
          created_at: bill.quotations.created_at,
          items: bill.quotations.items,
          date: bill.date,
          subTotal: bill.subTotal,
          discount: bill.quotations.discounts,
          discount_type: bill.quotations.discount_type,
          total: bill.total,
          billNumber: bill.billNumber,
          seller: localStorage.getItem("token"),
          customer: bill.quotations.customerName,
          change: bill.change,
          paid: bill.paid,
          ledger_id: bill.quotations.ledger_id,
        },
      },
    },
  });
};
export const createSaleLedger = (ledger) => {
  return LedgersRepository.ledgerModel({
    request: {
      method: "updateSaleLedger",
      data: {
        _id: ledger._id,
        sale: {
          srNum: ledger.srNum,
          date: ledger.date,
          detail: ledger.detail,
          billNumber: ledger.billNumber,
          totalAmount: ledger.totalAmount,
          depositedAmount: ledger.depositedAmount ? ledger.depositedAmount : 0,
          remainingAmount: ledger.remainingAmount ? ledger.remainingAmount : 0,
        },
      },
    },
  });
};
export const mutateItems = (items) => {
  return DefaultRepository.defaultModel({
    request: {
      method: "updateItem",
      data: {
        items: items,
        action: "Sold",
        user: localStorage.getItem("token"),
      },
    },
  });
};
